import * as React from 'react'

import * as Style from './style.css'

export interface IProps
  extends Omit<React.ComponentPropsWithoutRef<'button'>, 'className'> {
  color: 'primary' | 'secondary'
}

export const Button = React.forwardRef<HTMLButtonElement, IProps>(
  ({ color, ...props }, ref) => (
    <button
      className={
        color === 'primary' ? Style.ButtonPrimary : Style.ButtonSecondary
      }
      {...props}
      ref={ref}
    />
  ),
)
